import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, Table, Pagination, Modal } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { SearchBlueIcon } from 'assets/icons';
import { DriverService } from 'services';
import ModalFiles from './modal-files';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	search_by: ''
}

class Drivers extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Item',
			'Nombre',
			'Email',
			'Teléfono',
			'Ciudad',
			'¿Propietario de camión?',
			'¿Conductor activo?',
			'Información',
			'Opciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible_files: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Conductores',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		const res: any = await DriverService.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form
		});
		this.setState({
			data: res.drivers?.rows?.map((item: any, index: number) => {
				item._index = (this.state.page - 1) * Constants.PER_PAGE + (index + 1)
				return item;
			}) || [],
			last_page: res.drivers?.count || 1
		});
	}

	submit = async (e: any) => {
		e.preventDefault();
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	invitation = () => {
		this.props.history.push({
			pathname: `/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/drivers/invitations`,
			state: {
				create: true
			}
		});
	}

	delete = (item: any) => {
		Globals.confirm('¿Desea eliminar el conductor?',async () => {
			await DriverService.delete({
				driver_id: item?.id
			});
			this.load(true);
		});
	}

	changeStatus = (item: any) => {
		Globals.confirm('¿Desea cambiar de estatus al conductor?',async () => {
			await DriverService.changeStatus({
				driver_id: item.id
			});
			this.load(true);
		});
	}

	changeOwner = (item: any) => {
		Globals.confirm('¿Desea cambiar de estatus de propiedad del camión al conductor?',async () => {
			await DriverService.changeOwner({
				driver_id: item.id
			});
			this.load(true);
		});
	}

	onCloseFiles = () => {
		this.setState({
			visible_files: false,
			item: null
		});
	}

	viewFiles = (item: any) => {
		this.setState({
			visible_files: true,
			item
		});
	}

	render() {
		const { visible_files } = this.state;

		return (
			<div id="drivers">
				<Modal
		          className="modal-view-driver-files"
		          visible={ visible_files }
		          title="Permisos"
		          onClose={ () => this.onCloseFiles() }
		        >
		        	{/*
		        	// @ts-ignore */}
		        	<ModalFiles
		        		item={ this.state.item }
		        	/>
		      	</Modal>

				<div className="row" style={{ marginBottom: '20px', alignItems: 'center' }}>
					<div className="col-md-6">
						<p className="label-search">Filtrar usuario</p>
						<div className="container-search">
							<Select
								name="search_by"
								placeholder="Buscar por"
								onChange={ (e: any) => this.change(e) }
								value={ this.state.form.search_by }
								options={ [
									{ value: 'name', label: 'Nombre' },
									{ value: 'email', label: 'Correo' },
									{ value: 'phone', label: 'Teléfono' },
									{ value: 'city', label: 'Ciudad' },
								] }
							/>
							<Input
								value={ this.state.form.search }
								name="search"
								placeholder="Buscar"
								className="input-table"
								notMui
								searchRight
								searchIcon={ SearchBlueIcon }
								onSubmit={ () => this.load() }
								onChange={ (e: any) => {
									clearTimeout(this.timer);
									this.timer = setTimeout(() => {
										this.load(true);
									},1000);
									this.change(e); 
								} } />
						</div>
					</div>
					<div className="col-md-6 text-right">
						<button className="btn btn-add" onClick={ this.invitation }>
							<p>Invitar chofer</p>
							<div className="add">
								+
							</div>
						</button>
					</div>
				</div>

				<div className="tabs">
					<button
						type="button"
						className="tab"
						onClick={() => {} }
						data-active={ true }
					>
						Usuarios
					</button>

					<button
						type="button"
						className="tab"
						onClick={() => this.props.history.replace(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/drivers/invitations`) }
						data-active={ false }
					>
						Invitaciones Enviadas
					</button>
				</div>
				<Table title="Conductores" data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i._index }</td>
								<td>{ i.name }</td>
								<td>{ i.email }</td>
								<td>{ i.phone }</td>
								<td>{ i.city }</td>
								<td>
									<div className="check-container">
										<div className={ `check ${ i.owner == Constants.DRIVER_OWNER.YES ? 'active' : '' }` } onClick={ () => this.changeOwner(i) }>
											<div className="check-circle"></div>
										</div>
										<p className="label-status">{ i.owner == Constants.DRIVER_OWNER.YES ? 'Si' : 'No' }</p>
									</div>
								</td>
								<td>
									<div className="check-container">
										<div className={ `check ${ i.status == Constants.ASSISTANT_STATUS.ACTIVE ? 'active' : '' }` } onClick={ () => this.changeStatus(i) }>
											<div className="check-circle"></div>
										</div>
										<p className="label-status">{ i.status == Constants.ASSISTANT_STATUS.ACTIVE ? 'Si' : 'No' }</p>
									</div>
								</td>
								<td>
									{/*<button className="btn btn-transparent" onClick={ () => {
										Globals.showWarning("Función no disponible");
									} }>
										CSV
									</button>
									<button className="btn btn-transparent" onClick={ () => {
										Globals.showWarning("Función no disponible");
									} }>
										Historial
									</button>*/}
									<button className="btn btn-transparent" onClick={ () => {
										this.viewFiles(i);
									} }>
										Permisos
									</button>
								</td>
								<td>
									<button className="btn btn-update" onClick={ () => this.props.history.push(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/drivers/update/` + i.id) }>
										Editar
									</button>
									<button className="btn btn-delete" onClick={ () => this.delete(i) }>
										Eliminar
									</button>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Drivers);